import { render, staticRenderFns } from "./ReplacePhone.vue?vue&type=template&id=268122d0&scoped=true"
import script from "./ReplacePhone.vue?vue&type=script&lang=js"
export * from "./ReplacePhone.vue?vue&type=script&lang=js"
import style0 from "./ReplacePhone.vue?vue&type=style&index=0&id=268122d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268122d0",
  null
  
)

export default component.exports